import { useMemo } from 'react'
import useNormalizedFamilies from './useNormalizedFamilies'
import useProfile from './useProfile'
import { filterFamilyOptionsByViewerScope } from '../../modules/ac/visibilityScope'

const familyToSelectOption = ({ id, name, activeDeviceColor }) => ({
  value: id,
  label: name,
  activeDeviceColor: activeDeviceColor ?? null
})

const useFamiliesAsSelectOptions = () => {
  const families = useNormalizedFamilies()
  const profile = useProfile()

  return useMemo(() => {
    const options = families.map(familyToSelectOption)
    return filterFamilyOptionsByViewerScope(profile, options)
  }, [families, profile])
}

export default useFamiliesAsSelectOptions
